import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { Video } from "lucide-react";
import { useState } from "react";

import { useEditorI18n } from "../../lib/i18n";
import { resolveVideoUrl } from "../../lib/video";
import { replaceVideoInputWithEmbed } from "../../lib/video-node";
import "./video-embed-input.css";

export function VideoEmbedInputNodeView({ editor, getPos }: NodeViewProps) {
  const t = useEditorI18n();
  const [url, setUrl] = useState("");
  const [error, setError] = useState<string | null>(null);

  const submit = () => {
    const resolved = resolveVideoUrl(url);

    if (!resolved) {
      setError(t("video.error"));
      return;
    }

    setError(null);
    replaceVideoInputWithEmbed({
      editor,
      getPos,
      attrs: resolved,
    });
  };

  return (
    <NodeViewWrapper as="div" className="video-embed-input-node">
      <div className="video-embed-input-card" contentEditable={false}>
        <div className="video-embed-input-icon-shell">
          <div className="video-embed-input-icon-card">
            <Video className="video-embed-input-icon" strokeWidth={2} />
          </div>
        </div>
        <div className="video-embed-input-copy">{t("video.prompt")}</div>
        <div className="video-embed-input-supported">{t("video.supported")}</div>
        <div className="video-embed-input-row">
          <input
            className="video-embed-input-field"
            onChange={(event) => setUrl(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                submit();
              }
            }}
            placeholder={t("video.placeholder")}
            type="url"
            value={url}
          />
          <button className="video-embed-input-button" onClick={submit} type="button">
            {t("common.insert")}
          </button>
        </div>
        {error ? <div className="video-embed-input-error">{error}</div> : null}
      </div>
    </NodeViewWrapper>
  );
}
